import { VideoRenderDto } from "@repo/api/video-render";
import { ThirdPartyEditorInfoDto } from "@repo/api/third-party-video";

export function getStatus(
  videoRender: VideoRenderDto | null,
): "rendering" | "failed" | "done" | "deleted" {
  if (
    !videoRender ||
    videoRender.status === "rendering" ||
    videoRender.status === "upscaling"
  ) {
    return "rendering";
  }

  if (
    !videoRender.vimeoInfo ||
    videoRender?.status === "failed" ||
    videoRender?.vimeoInfo?.status === "failed"
  ) {
    return "failed";
  }

  if (videoRender.vimeoInfo?.status === "deleted") {
    return "deleted";
  }

  if (
    videoRender.status === "done" &&
    videoRender.vimeoInfo?.status === "done"
  ) {
    return "done";
  }

  return "rendering";
}

export function getTitle(
  videoRender: VideoRenderDto | null,
  thirdPartyEditorInfo: ThirdPartyEditorInfoDto | null,
) {
  const status = getStatus(videoRender);
  const isTpAutoSend =
    thirdPartyEditorInfo?.exportConfig.availableExports.VIMEO?.mode ===
    "TP_AUTO_SEND";

  if (status === "failed") {
    return "Failed to upload video to Vimeo";
  }

  if (status === "done") {
    if (isTpAutoSend) {
      return `Video sent to ${thirdPartyEditorInfo.displayName}`;
    }

    return "Video uploaded to Vimeo";
  }

  if (status === "deleted") {
    return "Video deleted from Vimeo";
  }

  return "Your video is being rendered...";
}

export function getDescription(
  videoRender: VideoRenderDto | null,
  thirdPartyEditorInfo: ThirdPartyEditorInfoDto | null,
): string | React.ReactNode {
  const status = getStatus(videoRender);
  const isTpAutoSend =
    thirdPartyEditorInfo?.exportConfig.availableExports.VIMEO?.mode ===
    "TP_AUTO_SEND";

  if (status === "failed") {
    return "Please try again or contact support.";
  }

  if (status === "done") {
    if (isTpAutoSend) {
      return `Vimeo link is now available in ${thirdPartyEditorInfo.displayName}.`;
    }

    return "You can now share the video with others.";
  }

  if (status === "deleted") {
    return "The video is no longer available through the link.";
  }

  if (isTpAutoSend) {
    return `Video will be automatically sent to ${thirdPartyEditorInfo.displayName} once it's rendered.`;
  }

  return "Vimeo link will be available once rendering is complete.";
}
